import { useEffect, useState } from 'react';
import { ClinicalKeyLink } from 'models/ui';
import { apiHelper, chartHelper } from 'helpers';
import { assignmentService } from 'services';
import { ELSButton } from 'components/common/els';

export interface DrugNameBtnRedirectProps {
  areaName?: string;
  showLink?: boolean;
  drugName?: string;
  isDisabled?: boolean;
}

const DrugNameBtnRedirect = (props: DrugNameBtnRedirectProps) => {
  const [link, setLink] = useState<ClinicalKeyLink[]>();

  useEffect(() => {
    if (props.drugName && props.showLink) {
      const linksArr = [];
      assignmentService
        .getDrugInfoURL(chartHelper.filterDrugByFirstName(props.drugName))
        .then((res) => {
          if (res.data) {
            linksArr.push({ name: props.drugName, url: res.data });
            setLink(linksArr);
          }
        })
        .catch((err) => apiHelper.showApiError(`can not load clinical pharmacology link ${err}`));
    }
  }, [props.drugName, props.showLink]);

  const drugInfoUrl = link?.find((obj) => props.drugName === obj.name)?.url;

  return <ELSButton type="link" text={props.drugName} onClick={() => window.open(drugInfoUrl || '', '_blank', 'noopener,noreferrer')} isDisabled={props.isDisabled} />;
};

DrugNameBtnRedirect.displayName = 'DrugNameBtnRedirect';
export default DrugNameBtnRedirect;
